import { LinkItem } from "@comparaonline/ui-filter-list";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRulesCallback = theme => ({
  highlight: {
    fontWeight: theme.typography.fontWeightMedium
  }
});

interface TravelFilterLinkProps extends WithStyles<typeof styles> {
  title: React.ReactText;
  url: string;
}

export const BaseFilterLink: React.FC<TravelFilterLinkProps> = ({ title, url }) => (
  <LinkItem title={title} href={url} />
);

export const TravelFilterLink = withStyles(styles)(BaseFilterLink);
